import React, { useState, useCallback, useEffect } from 'react'
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { Row, Col, Table, Form, Button } from 'react-bootstrap';
import { API } from 'api/API'
import { BUSINESS_REPORT_PAYMENTS_BY_DONCAUSE, BUSINESS_DONATION_CAUSES } from 'config/config'
import { extractBlobError } from 'api/ErrorUtil';
import { SubmitButton } from 'uiwidgets/SubmitButton';
import { isValidDate } from 'util/Validators';
import { convertToISOString, stringToDateEndOfDay, stringToDateBeginningOfDay } from 'util/Date';
import _ from "lodash"

const PaymentsByDonationCause = () => {

    const initialState = {
        errors: {},
        infoMessage: "",
        readOnly: false,
        editMode: false,
        donationCauseIds: [],
        donationCauses: []
    }

    const initialValidationState = {
        fromDateError: false,
        fromDateErrMsg: "",
        toDateError: false,
        toDateErrMsg: "",
        donationCauseIdsError: false,
        dontaionCauseIdsErrMsg: ""
    }

    const messageReset = () => {
        return {
            infoMessage: "",
            errors: {}
        }
    }

    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }

    const [formData, setFormData] = useState(initialState);
    let [formValidityData, setFormValidityData] = useState(initialValidationState);

    const fetchDonationCauses = useCallback(async () => {
        try {
            let donationCausesResponse = await API.get(BUSINESS_DONATION_CAUSES + "?nonactive=true")
            let donationCauses = donationCausesResponse.data;
            setFormData({
                ...formData,
                donationCauses: donationCauses
            });
        } catch (err) {
            let exError = await extractBlobError(err);
            setFormData({
                initialState,
                errors: exError
            })
        }
    });

    useEffect(() => {
        console.log("Fetching donation causes");
        fetchDonationCauses();
    }, []);

    const handleChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handleValidation = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;

        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const handleCheckBoxChange = (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;

        let donationCauseIds = [];
        if (event.target.checked) {
            donationCauseIds.push(value);
        }

        for (let dcId of formData.donationCauseIds) {
            if (!event.target.checked && dcId === value) {
                //dont put back the value into array
            } else {
                donationCauseIds.push(dcId);
            }
        }
        setFormData({
            ...formData,
            donationCauseIds: donationCauseIds
        })
    }

    const handleCheckAll = () => {
        let donationCauseIds = [];
        for (let i = 0; i < document.getElementsByTagName('input').length; i++) {

            let element = document.getElementsByTagName('input')[i];
            if (element.type !== 'checkbox') {
                continue;
            }
            element.checked = true;
            donationCauseIds.push(element.value);
            setFormData({
                ...formData,
                donationCauseIds: donationCauseIds
            })

        }
    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "fromDate":
                if (value.trim() === '') {
                    hasError = true
                    error = "From Data is required"
                } else if (!isValidDate(value)) {
                    hasError = true
                    error = "From Date is not valid"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "toDate":
                if (value.trim() === '') {
                    hasError = true
                    error = "To Date is required"
                } else if (!isValidDate(value)) {
                    hasError = true
                    error = "To Date is not valid"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            default:
                break;
        }
        return { hasError, error };
    }


    const downloadReport = async (event) => {
        event.preventDefault();

        //validate date fields
        for (let i = 0; i < event.target.getElementsByTagName('input').length; i++) {
            let fieldName = event.target.getElementsByTagName('input')[i].name;
            let fieldValue = event.target.getElementsByTagName('input')[i].value;
            let { hasError, error } = validateInput(fieldName, fieldValue);
            setFormValidityData({
                ...formValidityData,
                [fieldName + 'Error']: hasError,
                [fieldName + 'ErrMsg']: error
            })
            if (hasError) {
                alert("Form has validation error")
                return false;
            }
        }

        if (_.isEmpty(formData.donationCauseIds)) {
            alert("Atleast one donation cause must be selected");
            setFormValidityData({
                ...formValidityData,
                donationCauseIdsError: true,
                dontaionCauseIdsErrMsg: "Select atleast one donation cause"
            });
            return false;
        }

        try {
            let response = await API.post(BUSINESS_REPORT_PAYMENTS_BY_DONCAUSE, {
                donationCauseIds: formData.donationCauseIds,
                fromDate: formData.fromDate ? convertToISOString(stringToDateBeginningOfDay(formData.fromDate)) : null,
                toDate: formData.toDate ? convertToISOString(stringToDateEndOfDay(formData.toDate)) : null
            }, { responseType: "blob" });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "PaymentReportByDonationCause.xlsx");
            document.body.appendChild(link);
            link.click();

        } catch (err) {

            let { message, errors, httpStatus } = await extractBlobError(err);
            if (httpStatus === 404) {
                setFormData({ ...formData, infoMessage: "No Data was found" })
            } else {

                setFormData({
                    ...formData,
                    errors: { message, errors, httpStatus }
                })
            }
        };

    }
    return (
        <FormContainer title="Account Types" submitButtonFunction={downloadReport}
            errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
            <Row>
                <Col sm={4} md={2} lg={2}>
                    <FormField
                        name="fromDate"
                        label="From Date"
                        type="date"
                        readOnly={formData.readOnly}
                        value={formData.fromDate}
                        placeholder="Enter From Date"
                        onChange={handleChange}
                        onBlur={handleValidation}
                        valstate={!formValidityData.fromDateError} valMsg={formValidityData.fromDateErrMsg} />
                </Col>
                <Col sm={4} md={2} lg={2}>
                    <FormField
                        name="toDate"
                        label="To Date"
                        type="date"
                        readOnly={formData.readOnly}
                        value={formData.toDate}
                        placeholder="Enter To Date"
                        onChange={handleChange}
                        onBlur={handleValidation}
                        valstate={!formValidityData.toDateError} valMsg={formValidityData.toDateErrMsg} />
                </Col>
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>Select One or More Donation Causes or <Button variant="link" className="border-0 m-0 p-0" onClick={handleCheckAll}>check all</Button></Col>
            </Row>
            <Row>
                <Col>
                    <Table><tbody>
                        {formData.donationCauses && formData.donationCauses.map((donCause, idx) => {

                            return (
                                <tr key={idx}><td className='m-0 p-0' width="20px">
                                    <FormField type="checkbox" name="donationCauseIds" value={donCause.id}
                                        onChange={handleCheckBoxChange} checked={formData.donationCauseIds.includes(donCause.id)}
                                        valstate={!formValidityData.donationCauseIdsError} valMsg={formValidityData.dontaionCauseIdsErrMsg} />
                                </td><td className='m-0 p-0'>{donCause.donationCauseDescription}</td>
                                </tr>
                            );
                        }
                        )}
                    </tbody></Table>
                </Col>
            </Row>
            <Row>
                <Col>
                    <SubmitButton label="Download Report" />
                </Col>
            </Row>
        </FormContainer>

    )
}

export default PaymentsByDonationCause